import { useParams } from "react-router-dom";

const useIsGodMode = () => {
  const { teamId } = useParams();

  return teamId === "all";
};

export default useIsGodMode;
